<template>
    <div>
        <div
            class="count-container fashion"
            :class="{ sold: info.listingStatus == 'Sold' }"
        >
            <div class="item" v-if="countInfo.bedrooms">
                <span class="number">{{
                    countInfo.bedrooms.num
                }}</span>
                <span class="house">{{countInfo.bedrooms.unit}}</span>
            </div>
            <div class="item" v-if="countInfo.bathrooms">
                <span class="number">{{
                    countInfo.bathrooms.num
                }}</span>
                <span class="house">{{ countInfo.bathrooms.unit }}</span>
            </div>
            <div
                class="item"
                v-if="countInfo.sqft"
            >
                <span class="number">{{
                    countInfo.sqft.num
                }}</span>
                <span class="house">{{
                    countInfo.sqft.unit
                }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from '@/store/helpers';
import { getCountObj } from '../../info-header-count.js';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['filling'],
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            'info': store => store.listingDetail.info || {}
        }),
        countInfo({ info }) {
            return getCountObj.call(this, info);
        }
    }
};
</script>
<style lang="scss">
.count-container.fashion {
    display: flex;
    align-items: center;
    color: #bfc9e4;
    &:first-child {
        margin-right: 0;
    }
    .item {
        font-size: 16px;
        margin: 0px 10px;
        .number {
            font-family: var(--font-bold);
            color: #ffffff;
        }
        .house {
            color: #8195bd;
        }
        &:first-child {
            margin-left: 0;
        }
        &:after {
            content: '.';
            position: relative;
            left: 10px;
            top: -5px;
        }
        &:nth-last-child(1):after {
            content: '';
        }
        &:nth-last-child(1) {
            margin-right: 15px;
        }
    }
    .item-separator {
        margin-top: -10px;
    }
}
@media (max-width: 600px) {
    .count-container.fashion {
        margin-top: 8px;
        &:first-child {
        }
        .item {
            font-size: 14px;
            .number {
            }
            .house {
            }
            &:first-child {
            }
        }
        .item-separator {
        }
    }
}
</style>
